import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { FINANCE_FLOW_STORAGE_KEYS } from 'src/app/pages/financing-flow/finance-flow-v3/finance-flow.constants';

@Injectable({
  providedIn: 'root'
})
export class FinancingService {
  financeData: any = this.getStoredFinanceData();
  paymentProcessData: any = {};
  downPaymentThresholds = {
    min: 0,
    max: 0
  };
  doctorSettingFinanceData: any;

  constructor(private router: Router) {}

  saveFinanceData(data: any): void {
    this.financeData = {
      ...(this.financeData || {}),
      ...(data || {})
    };
    localStorage.setItem(FINANCE_FLOW_STORAGE_KEYS.FINANCE_DATA, JSON.stringify(this.financeData));
  }

  savePaymentProcessData(data: any): void {
    this.paymentProcessData = {
      ...(this.paymentProcessData || {}),
      ...(data || {})
    };
  }

  clearFinanceData(): void {
    this.financeData = {};
    this.paymentProcessData = {};
    this.downPaymentThresholds = {
      min: 0,
      max: 0
    };
    localStorage.removeItem(FINANCE_FLOW_STORAGE_KEYS.FINANCE_DATA);
  }

  cancelPlan(): void {
    this.clearFinanceData();
    this.router.navigate(['/app/finance-customer']);
  }

  getCancellationReasons(): void {
    // Placeholder for later v3 steps. The first screen only needs this call to be safe.
  }

  private getStoredFinanceData(): any {
    try {
      return JSON.parse(localStorage.getItem(FINANCE_FLOW_STORAGE_KEYS.FINANCE_DATA) || '{}');
    } catch (e) {
      return {};
    }
  }
}
